module.exports = __webpack_public_path__ + "img/feedback-fail.74684384.png";